import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { AnnulationComponent } from './annulation/annulation.component';
import { FormfnsComponent } from './formfns/formfns.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { FormfnsimpleCommonModule } from '../common/formfns.module';
import { TypeFNSSimpleDescMarche2Component } from './typeFNSSimpleDescMarche2/typeFNS-simple-desc-marche2.component';
import { TypeNatureMarcheChoixComponent } from './typeNatureMarcheChoix/type-nature-marche-choix.component';

@NgModule({
	declarations: [
		TypeCPVClassComponent,
		TypeObjCPVComponent,
		AvisInitialTypeComponent,
		AnnulationComponent,
		FormfnsComponent,
		Step1Component,
		Step2Component,
		Step3Component,
		Step4Component,
		TypeFNSSimpleDescMarche2Component,
		TypeNatureMarcheChoixComponent,
	],
	exports: [FormfnsComponent],
	imports: [CommonModule, ReactiveFormsModule, SharedModule, FormfnsimpleCommonModule],
})
export class FormfnsAnnulationModule {}
